export default "__VITE_ASSET__CSjnACd6__"